module.exports = __webpack_public_path__ + "img/logo-fr-bw.7f630c32.png";